import { InputText } from 'primereact/inputtext';
import React, { useEffect, useRef, useState } from 'react';
import 'react-phone-number-input/style.css'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import eventBus from '../common/EventBus';
import SearchService from '../service/SearchService';
import CustomSearchItem from './CustomSearchItem';
import CustomArtLabel from './CustomArtLabel';
import Constants from '../constants/Constants';
import CustomExhibitions from './CustomExhibitions';
import { Button } from 'primereact/button';

const CustomSearch = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();


    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [search, setSearch] = useState('');
    const [searchResponse, setSearchResponse] = useState('');
    const [debouncedTerm, setDebouncedTerm] = useState('');
    const [searchInfo, setSearchInfo] = useState('');


    useEffect(() => {
        if (props?.companyCode?.length > 0 || props?.searchText?.length > 0) {
            onSearch();
        }
        else if (props?.onLoad === true) {
            onSearch();

        }

    }, []);

    /**
     * Function to handle the key down event of the search input.
     * If the key is Enter, it will call the onSearch function.
     * @param {event} e - The key down event.
     */
    const onKeyDown = (e) => {
        //   console.log("onKeyDown", search + e.key);

        if (e.key === 'Enter') {
            onSearch(true);
        }//else if(e.key.length)


    }

    // Debounce işlemi
    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedTerm(search);
        }, 500); // 500ms bekleme süresi

        return () => {
            clearTimeout(timerId);
        };
    }, [search]);

    // Debounced terim değiştiğinde arama işlemini gerçekleştir
    useEffect(() => {
        if (debouncedTerm.length >= 3) {
            // Arama işleminizi burada gerçekleştirin
            onSearch(true);

            console.log('Arama yapılıyor:', debouncedTerm);
        }
    }, [debouncedTerm]);

    const onSearch = (param) => {
        console.log("onSearch", search, param);
        setDisplayLoadingDialog(true);
        setSearchResponse([]);
        setSearchInfo("");
        let _companyCode = props.companyCode ? props.companyCode : "";
        let _search = search?.length > 0 ? search : props.searchText?.length > 0 ? props.searchText : "";
        let _searchType = props.searchType ? props.searchType : "";
        if (param) {
            _companyCode = "";
            _searchType = ""
        }
        console.log(" SearchService.search", _search, _companyCode, _searchType);

        SearchService.search(_search, _companyCode, _searchType).then(
            (response) => {

                console.log("search", response)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set search", response?.data?.data?.dataList)
                    setSearchResponse(response?.data?.data?.dataList[0]);
                    let _response = response?.data?.data?.dataList[0];
                    if (_response?.artistList?.length == 0 && _response?.artworkList?.length == 0 && _response?.companyList?.length == 0 && _response?.exhibitList?.length == 0) {
                        console.log("****************set search not found")

                        setSearchInfo(t("global_text_no_found"));
                    }
                }


                setDisplayLoadingDialog(false);
            },
            (error) => {
                console.log("inquireCharVal error*", error)

                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireCharVal logout******")
                    eventBus.dispatch("logout", props);
                } else {
                    props.toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }


    const renderArtists = () => {
        console.log("renderArtists", searchResponse, searchResponse?.artistList?.length)
        return (
            <div className='pt-2  p-2'>
                {searchResponse?.artistList?.length > 0 &&
                    <div>
                        <div className='text-2xl  font-500-regular pt-2 pb-3'>
                            {t('search_artists')}
                        </div>
                        <div className="grid" >
                            {searchResponse.artistList.map((param, index) => {
                                return (
                                    <a key={index} href={"/profile/" + param.id + "/" + Constants.userType.artist} className="flex align-items-center hover:text-gray-400 transition-duration-200 mt-2">
                                        <CustomArtLabel key={index} background='rgba(255,255, 255, 0.65)' textColor='black' image={param.filePath} label={param.ownerName} style={{ marginLeft: 5, }} />
                                    </a>
                                )
                            })
                            }

                        </div>
                    </div>
                }
            </div>
        )

    }

    const renderCompanies = () => {
        console.log("renderCompanies", searchResponse, searchResponse?.companyList?.length)
        return (
            <div className='pt-2  p-2'>
                {searchResponse?.companyList?.length > 0 &&
                    <div>
                        <div className='text-2xl  font-500-regular pt-2 pb-3'>
                            {t('search_companies')}
                        </div>
                        <div className="grid" >
                            {searchResponse.companyList.map((param, index) => {
                                return (
                                    <a key={index} href={"/profile/" + param.id + "/" + Constants.userType.company} className="flex align-items-center hover:text-gray-400 transition-duration-200 mt-2">
                                        <CustomArtLabel key={index} background='rgba(255,255, 255, 0.65)' textColor='black' image={param.filePath} label={param.companyName} style={{ marginLeft: 5, }} />
                                    </a>
                                )
                            })
                            }

                        </div>
                    </div>
                }
            </div>
        )

    }

    const renderArtWorks = () => {
        console.log("renderArtWorks", searchResponse, searchResponse?.artworkList?.length)
        return (
            <div className='pt-2  p-2'>
                {searchResponse?.artworkList?.length > 0 &&
                    <div>
                        <div className='text-2xl  font-500-regular pt-2 pb-2'>
                            {t('search_artworks')}
                        </div>
                        <CustomSearchItem data={searchResponse?.artworkList} type={Constants.entityNames.artwork} {...props} searchType={props.searchType} search={search}></CustomSearchItem>
                    </div>
                }

            </div>
        )

    }




    const renderExhibits = () => {
        return (
            <div className='pt-2  p-2 '>
                {searchResponse.exhibitList?.length > 0 &&
                    <div>
                        <div className='flex flex-row justify-content-between w-12'>
                            <div className='text-2xl  font-500-regular pt-2 pb-2'>
                                {t('search_exhibitions')}
                            </div>
                        </div>

                        <CustomSearchItem data={searchResponse.exhibitList} type={Constants.entityNames.exhibition} earchType={props.searchType} search={search}></CustomSearchItem>

                    </div>
                }
            </div>
        )

    }


    return (
        <div style={{
            ...props.containerStyle,
            //width: props.width ? props.width : "100%",
            width: 700,

        }}>
            <div className="grid p-fluid justify-content-center
            ">
                <div className="col-12 md:col-12">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText id="search" value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => onKeyDown(e)} autoComplete="off"
                            className="inputtext_raunded p-inputtext " type="text" placeholder={props.placeholder ? props.placeholder : t('global_text_search')}></InputText>
                    </span>
                </div>
                {
                    searchResponse &&
                    <div className='grid flex flex-column pl-5 pr-5 search-dialog-content-bg'               >
                        {
                            searchInfo &&
                            <div className='text-2xl  font-500-regular pt-2 pb-3 '>
                                {searchInfo}
                            </div>
                        }
                        {renderArtists()}
                        {renderCompanies()}

                        {renderArtWorks()}
                        {renderExhibits()}

                    </div>
                }



            </div>
            {
                searchResponse &&
                <div className="grid flex justify-content-center  align-items-center " style={{ marginTop: 20 }}
                >
                    <Button className={"p-button-rounded  mr-2 mb-2 flex justify-content-center  align-items-center "} label={t('search_result_all')}
                        onClick={() => {
                            props.clear();
                            navigate("/search/?searchType=ALL&searchText=" + search);

                        }}
                    > </Button>
                </div>
            }

        </div>
    )
}

export default CustomSearch;